import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";

export const COLUMN_ORDER = `minmax(12rem, 4fr) 1fr 1.5fr ${dropdownEllipsisWidth}`;
